import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { corporateClientColumns } from "../../Data/Configuration/CorporateClient";
import { Spinner } from "../../AbstractElements";
import CustomizerContext from "../../_helper/Customizer";
import { couponsColumns } from "../../Data/Configuration/Coupons";
import CommonToolTip from "../Common/Component/CommonToolTip";
import DeleteCoupon from "./DeleteCoupon";
import EditCoupon from "./EditCoupon";

const CouponTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    loader,
    onEditClick,
    couponObj,
    setCouponObj
}) => {
    const [deleteId, setDeleteId] = useState("")
    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () =>
        setDeleteModal(!deleteModal);
    const [editAction, setEditAction] = useState("")
    const [editModal, setEditModal] = useState(false);
    const toggleEditModal = () =>
        setEditModal(!editModal);

    const { mix_background_layout } = useContext(CustomizerContext)

    const processData = tableData.map((element, index) => {
        return {
            code: element.code ? element.code : "-",
            isActive: element.isActive ? "true" : "false",
            isApplicableForOldUser: element.isApplicableForOldUser ? "true" : "false",
            isVisible: element.isVisible ? "true" : "false",
            title: element.title ? element.title : "-",
            description: element.description ? <>
                <span
                    id={"description" + index}
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                    }}
                >
                    {element.description}
                </span>
                <CommonToolTip
                    options={{
                        placement: "left",
                        target: "description" + index,
                    }}
                >
                    {element.description}
                </CommonToolTip>
            </> : "-",
            validFrom: element.validFrom
                ? moment(new Date(element.validFrom)).format("MMM DD HH:mm")
                : "-",
            validUpto: element.validUpto
                ? moment(new Date(element.validUpto)).format("MMM DD HH:mm")
                : "-",
            value: element.value ? `${element.value} ${element.valueType}` : '-',
            action: (
                <ActionOptions key={index}>
                    <Fragment>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => onEditClick(element)}
                        >
                            <i className="fa fa-pencil"></i> Edit
                        </DropdownItem>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                                if (element?.isDeleted) {
                                    setEditAction("recover")
                                    setCouponObj(element)
                                    toggleEditModal()
                                } else {
                                    setDeleteId(element?.id)
                                    toggleDeleteModal()
                                }
                            }}
                        >
                            <i className="fa fa-trash-o"></i> {element?.isDeleted ? "Recover" : "Delete"}
                        </DropdownItem>
                        <DropdownItem
                            className="border-0"
                            key={"row-edit"}
                            onClick={() => {
                                if (element?.isActive) {
                                    setEditAction("deactivate")
                                } else {
                                    setEditAction("activate")
                                }
                                setCouponObj(element)
                                toggleEditModal()
                            }}
                        >
                            <i className="fa fa-ban"></i> {element?.isActive ? "Deactivate" : "Activate"}
                        </DropdownItem>
                    </Fragment>
                </ActionOptions>
            ),
        };
    });
    return (
        <Fragment>
            <div className="table-responsive coupon-table">
                <DataTable
                    columns={couponsColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <DeleteCoupon
                LargeModaltoggle={toggleDeleteModal}
                title={"Delete"}
                Large={deleteModal}
                deleteId={deleteId}
                fetchData={fetchTableData}
            />
            <EditCoupon
                LargeModaltoggle={toggleEditModal}
                title={editAction}
                Large={editModal}
                deleteId={deleteId}
                fetchData={fetchTableData}
                couponObj={couponObj}
                action={editAction}
            />

        </Fragment>
    );
};

export default CouponTable;
